import React from 'react';
import { FadeIn } from './FadeIn';
import { BONUSES, BonusDetailCard } from '../data/bonusesData';
export function Bonuses() {
  return <section className="py-16 md:py-24 bg-cream" data-id="element-19">
      <div className="max-w-5xl mx-auto px-6 md:px-12" data-id="element-20">
        <div className="text-center mb-12 md:mb-16" data-id="element-21">
          <FadeIn data-id="element-22">
            <span className="uppercase tracking-[0.2em] text-xs text-ink-light mb-4 block" data-id="element-23">
              Bonos Exclusivos
            </span>
            <h2 className="font-serif text-3xl md:text-5xl text-ink mb-5 md:mb-6" data-id="element-24">
              Tres regalos para acelerar tu{' '}
              <em className="italic" data-id="element-25">transformación</em>.
            </h2>
            <p className="text-base md:text-lg text-ink-light font-light leading-relaxed max-w-2xl mx-auto" data-id="element-26">
              Solo por unirte hoy, además del Método recibes tres bonos
              cuidadosamente diseñados para que ningún día tu progreso dependa
              de la fuerza de voluntad.
            </p>
          </FadeIn>
        </div>

        {/* Each bonus is a card with image left + content right.  Cards are
            stacked vertically with breathing room between them. */}
        <div className="space-y-8 md:space-y-10" data-id="element-27">
          {BONUSES.map((bonus, index) => <FadeIn key={bonus.number} delay={0.05} data-id="element-28">
              <BonusDetailCard bonus={bonus} reversed={index % 2 === 1} data-id="element-29" />
            </FadeIn>)}
        </div>
      </div>
    </section>;
}